module.exports = __webpack_public_path__ + "static/media/16.a1036f6e.jpg";